import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideoEnd = () => {
  return (
    <g>
      <path d="m14.165.1309a.75.75 0 0 0 -.75.75v5.82l-11.205-6.4695a.75.75 0 0 0 -1.125.6495v14.2382a.75.75 0 0 0 1.125.6494l11.2051-6.47v5.82a.75.75 0 0 0 1.5 0v-14.2376a.75.75 0 0 0 -.7501-.75zm-11.58 13.6891v-11.64l10.08 5.82z" />
    </g>
  );
};

export default withIcon(IconVideoEnd);
